import { render } from "./MergeForm.vue?vue&type=template&id=71b80ffc"
import script from "./MergeForm.vue?vue&type=script&lang=js"
export * from "./MergeForm.vue?vue&type=script&lang=js"

import "./MergeForm.vue?vue&type=style&index=0&id=71b80ffc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__